export class CartQf {
  constructor() {
    this.cart = window.QF.cart;

    this.endpoints = {
      add: {
        url: 'cart/add.js',
        method: 'post'
      },
      get: {
        url: 'cart.js',
        method: 'get'
      },
      update: {
        url: 'cart/update.js',
        method: 'post'
      },
      change: {
        url: 'cart/change.js',
        method: 'post'
      },
      clear: {
        url: 'cart/clear.js',
        method: 'post'
      }
    };

    this.selectors = {
      cartDrawerContainer: '[cart-drawer-container]',
      cartTabs: '[side-cart-tab]',
      cartContent: '[side-cart-form]',
      savedCartTab: '[saved-cart-tab]',
      laterCartTab: '[save-later-cart-tab]',
      quickViewContainer: '[quick-view-container]',
      sideCartRecommendations: '[side-cart-recommendations]',
      sideCartRecommendationsSection: '[side-cart-recommendations-section]',
      sideCartRecommendationsContainer: '[side-cart-recommended-container]',
      cartRecommendations: '[cart-recommendations]',
      cartRecommendationsSlider: '[cart-recommendations-slider]',
      cartItemsContainer: '[cart-items-container]',
      cartCount: '[cart-count]',
      cart_Content: '.cart-content',
      openSideCartTrigger: '[open-side-cart]',
      sideCartInner: '[side-cart-inner]',
      cartContainer: '[cart-container]',
      freeDeliveryStatus: '[free-delivery-status]',
      sideCartTotal: '[side-cart-total]',
    };
  }

  dispatchEvent(event_name, includeCart) {
    let contents = null;
    if (includeCart) {
      contents = {
        detail: {
          cart: this.cart,
        },
      };
    }
    window.dispatchEvent(new CustomEvent(event_name, contents));
  }

  async add(data) {
    try {
      const responseData = await this.request('add', data);
      this.mergeWithCurrentCart(responseData);
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_added", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async get() {
    try {
      const response = await this.request('get');
      this.cart = response.data;
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const responseData  = await this.request('update', data);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async change(data) {
    try {
      const responseData  = await this.request('change', data);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async remove(variant_id) {
    try {
      const updates = {
        updates: {
          [variant_id]: 0,
        }
      };
      const { data: responseData } = await this.request('update', updates);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_removed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async clear() {
    try {
      const { data: responseData } = await this.request('clear');
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("cart_cleared", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async request(key, data) {
    try {
      const url = window.Shopify.routes.root + this.endpoints[key].url;
      const method = this.endpoints[key].method;
      const headers = {
        'Content-Type': 'application/json'
      };

      const response = await fetch(url, {
        method,
        headers,
        body: JSON.stringify(data)
      });


      if (response.ok) {
        return response.json();
      } else {
        throw await response.json();
      }
    } catch (error) {

      // Generate Toasty Message
      let options = {
        title: error.message,
        message: error.description,
        delay: 5000
      }
      window.toasty.addToast(options);
      // console.log('🚀🚀🚀 ERROR: ', error);
      // console.log('🚀🚀🚀 DATA: ', data);

      throw error;
    }
  }

  mergeWithCurrentCart(data) {
    if (data.items) {
      data.items.forEach((item) => {
        let index = this.cart.items.findIndex(e => e.id === item.id);
        if (index > -1) {
          this.cart.items[index] = item;
        } else {
          this.cart.items.push(item);
        }
      });
    }
  }

  freeDeliveryProgress(el) {
    const delivery_text_el = el.querySelector('[free-delivery-text]');
    let free_delivery_amount = el.dataset.freeDelivery;
    const free_delivery_amount_market = el.dataset.freeDeliveryMarket;
    if (free_delivery_amount_market != '') {
      free_delivery_amount = JSON.parse(free_delivery_amount_market)['amount'];
    } else if (free_delivery_amount != '') {
      free_delivery_amount = parseFloat(free_delivery_amount);
    }
    if (free_delivery_amount != '') {
      const delivery_progress_bar = el.querySelector('[f-del-bar]');
      const delivery_progress_marker = el.querySelector('[f-del-marker]');
      const free_delivery_currency = el.dataset.currencySymbol;
      const cart_total = document.querySelector(this.selectors.sideCartTotal).dataset.subTotal / 100;
      const progress_text = el.dataset.freeProgressText;
      const reached_text = el.dataset.reachedFreeText;

      if (cart_total < free_delivery_amount) {
        const spend_more = (free_delivery_amount - cart_total).toFixed(2);
        const spend_more_formatted = Shopify.formatMoney(spend_more,free_delivery_currency);
        delivery_text_el.innerHTML = `${spend_more_formatted} ${progress_text}`;

        // get progress percentage
        let progress = (cart_total / free_delivery_amount) * 100;
        delivery_progress_bar.style.width = `${progress}%`;
        delivery_progress_marker.style.left = `${progress}%`;

      } else {
        delivery_text_el.innerHTML = reached_text;
        delivery_progress_bar.style.width = '100%';
        delivery_progress_marker.style.left = '100%';
      }
    }
  }

  openSideCart() {
    this.reRenderSideCart(() => {
      const cart_tabs = document.querySelectorAll(this.selectors.cartTabs);
      const cart_content = document.querySelector(this.selectors.cartContent);
      const saved_content = document.querySelector(this.selectors.savedCartTab);
      const later_content = document.querySelector(this.selectors.laterCartTab);
      const quickview = document.querySelector(this.selectors.quickViewContainer);
      const cart_tab_content = document.querySelectorAll(this.selectors.cart_Content);

      if (quickview) {
        quickview.classList.remove('active');
      }

      cart_content.style.display = 'flex';
      saved_content.style.display = 'none';
      later_content.style.display = 'none';

      // cart_tabs[0].classList.add('active');
      // cart_tabs[1].classList.remove('active');

      for (let i = 0; i < cart_tabs.length; i++) {
        if (i !== 0) {
            cart_tabs[i].classList.remove('active');
        } else {
            cart_tabs[i].classList.add('active');
        }
      }

      cart_tab_content.forEach((content) => {
        if (!content.classList.contains('basket-cart')) {
          content.style.display = 'none';
        }
      });

      let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
      if (sideCartContainer) {
        sideCartContainer.classList.add("open");
        document.body.classList.add("fixed");
        sideCartContainer.style.height = window.innerHeight + "px";
        window.addEventListener("resize", () => {
          sideCartContainer.style.height = window.innerHeight + "px";
        });
        sideCartContainer.querySelector(this.selectors.sideCartRecommendations).classList.add('open');
        this.dispatchEvent("side_cart_opened", false);
      }
    });
  }

  closeSideCart() {
    let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
    if (sideCartContainer) {
      sideCartContainer.querySelector(this.selectors.sideCartRecommendations).classList.remove('open');
      sideCartContainer.classList.remove("open");
      document.body.classList.remove("fixed");
      this.dispatchEvent("side_cart_closed", false);
    }
  }

  showDiscountedItems(item) {
    let selected_for_you_swiper = document.querySelector('[side-cart-recommendations] .swiper-wrapper');
    let for_you_grid = document.querySelector('#cart-drawer [for-you-grid]');
    // const for_you_grid_cards = for_you_grid.querySelectorAll('[recommended-product]');
    const off_text = selected_for_you_swiper.dataset.offText;
    const free_text = selected_for_you_swiper.dataset.freeText;
    // const selected_for_you_swiper_cards = selected_for_you_swiper.querySelectorAll('[recommended-product]');
    const selected_for_you_swiper_discounted = selected_for_you_swiper.querySelectorAll('[discount-product]');
    const discount_free_handles = item.dataset.freeItems;
    const cart_product_handles = [];
    const cart_item_handles = document.querySelectorAll('[side-cart-item]');

    const current_discount_product_cards = document.querySelectorAll('[discount-product]');

    let current_discount_handles = [];
    current_discount_product_cards.forEach((card) => {
        current_discount_handles.push(card.dataset.handle);
    });

    cart_item_handles.forEach((cart_item) => {
        cart_product_handles.push(cart_item.dataset.productHandle);
    });

    let free_array = [];
    let discount_50_array = [];
    let discount_40_array = [];
    let discount_30_array = [];
    let discount_25_array = [];
    let discount_20_array = [];
    let discount_15_array = [];
    let discount_10_array = [];
    let discount_5_array = [];
    let cyk_array = [];

    if (discount_free_handles.length > 0) {
        free_array = discount_free_handles.split('#');
    }
    const discount_50_handles = item.dataset.discountFiftyItems;
    if (discount_50_handles.length > 0) {
        discount_50_array = discount_50_handles.split('#');
    }
    const discount_40_handles = item.dataset.discountFortyItems;
    if (discount_40_handles.length > 0) {
        discount_40_array = discount_40_handles.split('#');
    }
    const discount_30_handles = item.dataset.discountThirtyItems;
    if (discount_30_handles.length > 0) {
        discount_30_array = discount_30_handles.split('#');
    }
    const discount_25_handles = item.dataset.discountTwentyFiveItems;
    if (discount_25_handles.length > 0) {
        discount_25_array = discount_25_handles.split('#');
    }
    const discount_20_handles = item.dataset.discountTwentyItems;
    if (discount_20_handles.length > 0) {
        discount_20_array = discount_20_handles.split('#');
    }
    const discount_15_handles = item.dataset.discountFifteenItems;
    if (discount_15_handles.length > 0) {
        discount_15_array = discount_15_handles.split('#');
    }
    const discount_10_handles = item.dataset.discountTenItems;
    if (discount_10_handles.length > 0) {
        discount_10_array = discount_10_handles.split('#');
    }
    const discount_5_handles = item.dataset.discountFiveItems;
    if (discount_5_handles.length > 0) {
        discount_5_array = discount_5_handles.split('#');
    }
    const cyk_handles = item.dataset.cykItems;
    if (cyk_handles.length > 0) {
        cyk_array = cyk_handles.split('#');
    }

    // Join arrays
    const discount_handles = free_array.concat(
      discount_50_array,
      discount_40_array,
      discount_30_array,
      discount_25_array,
      discount_20_array,
      discount_15_array,
      discount_10_array,
      discount_5_array,
      cyk_array
  );

    // Create object with discount values
    let discount_values = {};
    if (free_array.length > 0) {
        free_array.forEach((handle) => {
            discount_values[handle] = free_text;
        });
    }
    if (discount_50_array.length > 0) {
        discount_50_array.forEach((handle) => {
            discount_values[handle] = `50% ${off_text}`;
        });
    }
    if (discount_40_array.length > 0) {
        discount_40_array.forEach((handle) => {
            discount_values[handle] = `40% ${off_text}`;
        });
    }
    if (discount_30_array.length > 0) {
        discount_30_array.forEach((handle) => {
            discount_values[handle] = `30% ${off_text}`;
        });
    }
    if (discount_25_array.length > 0) {
        discount_25_array.forEach((handle) => {
            discount_values[handle] = `25% ${off_text}`;
        });
    }
    if (discount_20_array.length > 0) {
        discount_20_array.forEach((handle) => {
            discount_values[handle] = `20% ${off_text}`;
        });
    }
    if (discount_15_array.length > 0) {
        discount_15_array.forEach((handle) => {
            discount_values[handle] = `15% ${off_text}`;
        });
    }
    if (discount_10_array.length > 0) {
        discount_10_array.forEach((handle) => {
            discount_values[handle] = `10% ${off_text}`;
        });
    }
    if (discount_5_array.length > 0) {
        discount_5_array.forEach((handle) => {
            discount_values[handle] = `5% ${off_text}`;
        });
    }
    if (cyk_array.length > 0) {
        cyk_array.forEach((handle) => {
            discount_values[handle] = ``;
        });
    }

    if (discount_handles.length > 0) {
      console.log('Discount handles',discount_handles);
        // selected_for_you_swiper_discounted.forEach((card) => {
        //   // remove all cards
        //   card.closest(".swiper-slide").remove();
        // });
        // selected_for_you_swiper_cards.forEach((card) => {
        //     card.style.display = 'none';
        //     card.remove();
        // });
        // for_you_grid_cards.forEach((card) => {
        //     card.style.display = 'none';
        // });
        let skus = [];
        let fragment = new DocumentFragment();
        async function fetchAndAppend() {
            const promises = discount_handles.map(async (handle) => {
                // check handle isn't in cart_product_handles

                if (!cart_product_handles.includes(handle) && !current_discount_handles.includes(handle)) {
                  try {
                      const response = await fetch(window.Shopify.routes.root + `products/${handle}?view=card&section_id=gb-product-card`);
                      if (response.ok) {
                          const data = await response.text();
                          const htmlDocument = new DOMParser().parseFromString(data, "text/html");
                          const productCard = htmlDocument.documentElement.querySelector(".product-card");
                          const productTitle = productCard.querySelector(".product-title");
                          const productSKU = productCard.dataset.sku;

                          if (productSKU) {
                              skus.push(productSKU);
                          }

                          if (productTitle.innerHTML !== "") {
                              // find discount value for product
                              const discount_value = discount_values[handle];
                              if (discount_value != '') {
                                  const discount_badge = document.createElement("div");
                                  discount_badge.classList.add('discount-badge');
                                  discount_badge.innerHTML = `${discount_value}`;
                                  productCard.querySelector('.product-image').append(discount_badge);
                              }
                              productCard.setAttribute('discount-product', '');
                              for_you_grid.insertAdjacentHTML('afterbegin', productCard.outerHTML);
                              let swiper_slide = document.createElement("div");
                              swiper_slide.classList.add('swiper-slide');
                              swiper_slide.insertAdjacentHTML('afterbegin', productCard.outerHTML);
                              return swiper_slide;
                          }
                      } else {
                          throw new Error("Error: " + response.status);
                      }
                  } catch (error) {
                      console.error(error);
                  }
                }
            });

            const swiperSlides = await Promise.all(promises);
            swiperSlides.forEach((swiperSlide) => {
              if (swiperSlide) {
                fragment.append(swiperSlide);
              }
            });

            // await for_you_grid.append(fragmentMobile);
            await selected_for_you_swiper.prepend(fragment);

            // loop through skus and api call to feefo to get reviews
            // skus.forEach(async (sku) => {
            //     try {
            //         const response = await fetch(`https://api.feefo.com/api/10/reviews/summary/product?since_period=ALL&product_sku=${sku}&merchant_identifier=ghostbikes-com&origin=www.ghostbikes.com`);
            //         if (response.ok) {
            //             const data = await response.json();
            //             const reviews = data.rating;
            //             console.log("🚀 ~ CartQf ~ skus.forEach ~ data.reviews:", data.rating.rating)
            //                 console.log("SKU",data.product.sku);
            //                 // const review_badge = document.createElement("div");
            //                 // review_badge.classList.add('review-badge');
            //                 // review_badge.innerHTML = `<div class="review-stars"><span class="feefo-stars" data-stars="${review_stars}"></span></div><div class="review-text">${review_text}</div><div class="review-author">${review_name}</div>`;
            //                 // const productCard = for_you_grid.querySelector(`[data-sku="${sku}"]`);
            //                 // if (productCard) {
            //                 //     productCard.querySelector('.product-image').append(review_badge);
            //                 // }
            //         } else {
            //             throw new Error("Error: " + response.status);
            //         }
            //     } catch (error) {
            //         console.error(error);
            //     }
            // });
          }

        fetchAndAppend();

        if (window.innerWidth > 767.98) {
          new window.swiper(".cart-recommendations-slider", {
              slidesPerView: 2,
              spaceBetween: 20,
              navigation: {
                  nextEl: ".swiper-button-next.cart-rec",
                  prevEl: ".swiper-button-prev.cart-rec",
              },
              lazy: {
                  enabled: true,
                  checkInView: false,
                  loadOnTransitionStart: true,
                  loadPrevNext: true,
                  loadPrevNextAmount: 1
              },
              breakpoints: {
                  1134: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                  },
                  1500: {
                      slidesPerView: 4,
                      spaceBetween: 30,
                  },
              },
          });
      }

    } else {
        // selected_for_you_swiper_cards.forEach((card) => {
        //     card.style.display = 'block';
        // });
        const removeCardsPromises = Array.from(selected_for_you_swiper_discounted).map((card) => {
          return new Promise((resolve) => {
              card.closest(".swiper-slide").remove();
              resolve();
          });
      });

        const for_you_grid_discounted = for_you_grid.querySelectorAll('[discount-product]');
        for_you_grid_discounted.forEach((card) => {
            // remove all cards
            card.remove();
        });
        // for_you_grid_discounted.forEach((card) => {
        //     card.style.display = 'none';
        // });
        Promise.all(removeCardsPromises).then(() => {
          // Initialize swiper after all cards are removed
          if (window.innerWidth > 767.98) {
              new window.swiper(".cart-recommendations-slider", {
                  slidesPerView: 2,
                  spaceBetween: 20,
                  navigation: {
                      nextEl: ".swiper-button-next.cart-rec",
                      prevEl: ".swiper-button-prev.cart-rec",
                  },
                  lazy: {
                      enabled: true,
                      checkInView: false,
                      loadOnTransitionStart: true,
                      loadPrevNext: true,
                      loadPrevNextAmount: 1
                  },
                  breakpoints: {
                      1134: {
                          slidesPerView: 3,
                          spaceBetween: 30,
                      },
                      1500: {
                          slidesPerView: 4,
                          spaceBetween: 30,
                      },
                  },
              });
          }
        });
    }
  }

  async reRenderSideCart(successCallback = null) {


    try {
      const response = await fetch(window.Shopify.routes.root + "cart?sections=gb-side-cart");
      if (!response.ok) {
        throw new Error("Error: " + response.status);
      }
      const data = await response.json();
      const html = data["gb-side-cart"];

      // UPDATE CART COUNT

      const side_cart_inner = document.querySelector(this.selectors.sideCartInner);
      if (side_cart_inner && html) {
        side_cart_inner.innerHTML = html;
          const updateCartCount = () => {
            console.log('Updating cart count');
            const cart = document.querySelector([this.selectors.cartItemsContainer]);
            let cart_count = parseInt(cart.getAttribute('data-items-count'));
            const cartCountEls = document.querySelectorAll(this.selectors.cartCount);

            if ( cart ) {

              cartCountEls.forEach(count_el => {
                if ( cart_count == 0 ) {
                  count_el.classList.add('empty-cart');
                } else {
                  count_el.classList.remove('empty-cart');
                }
                count_el.innerHTML = cart_count;
              });
            }
          }
        const free_delivery_el = document.querySelector(this.selectors.freeDeliveryStatus);
        if (free_delivery_el) {
          this.freeDeliveryProgress(free_delivery_el);
        }
        updateCartCount();

        let first_cart_item = side_cart_inner.querySelector('[side-cart-item]');

        if (first_cart_item) {
          this.showDiscountedItems(first_cart_item);
        } else {
          console.log('No cart items');
          let selected_for_you_swiper = document.querySelector('[side-cart-recommendations] .swiper-wrapper');
          const selected_for_you_swiper_cards = selected_for_you_swiper.querySelectorAll('[recommended-product]');
          let for_you_grid = document.querySelector('#cart-drawer [for-you-grid]');
          const for_you_grid_cards = for_you_grid.querySelectorAll('[recommended-product]');

          selected_for_you_swiper_cards.forEach((card) => {
            card.style.display = 'block';
          });
          for_you_grid_cards.forEach((card) => {
              card.style.display = 'flex';
          });
          if (window.innerWidth > 767.98) {
            new window.swiper(".cart-recommendations-slider", {
                slidesPerView: 2,
                spaceBetween: 20,
                navigation: {
                    nextEl: ".swiper-button-next.cart-rec",
                    prevEl: ".swiper-button-prev.cart-rec",
                },
                lazy: {
                    enabled: true,
                    checkInView: false,
                    loadOnTransitionStart: true,
                    loadPrevNext: true,
                    loadPrevNextAmount: 1
                },
                breakpoints: {
                    1134: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1500: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                },
            });
          }
        }


        this.cartRenderedEvent(response, html);

        if (successCallback) {
          successCallback();
        }
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  reRenderCart() {
    fetch(window.Shopify.routes.root + "cart?sections=gb-cart")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); // Parse the response as JSON
      })
      .then((data) => {
        let html = data["gb-cart"];
        let cart_inner = document.querySelector(this.selectors.cartContainer);
        if (cart_inner && html) {
          cart_inner.innerHTML = html;
          this.cartRenderedEvent(html);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  cartRenderedEvent(response, html) {
    const event = new CustomEvent("cart_rendered", {
      detail: {
        response,
        html,
      },
    });
    window.dispatchEvent(event);
  }
}

// export default new CartQf();
// window.CartQf = CartQf;
